const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

const uuid = () => {
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

const objectId = (m = Math, d = Date, h = 16, s = (s) => m.floor(s).toString(h)) =>
  s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h));

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const isImage = (url) => /\.(?:gif|png|jpe?g|svg|bmp|webp)$/i.test(url);

const isValidColor = (color) => {
  if (typeof color !== 'string') return false;

  if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color)) return true;

  if (/^rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*(,\s*[0-9]*\.?[0-9]+\s*)?\)$/.test(color)) return true;

  if (/^hsla?\(\s*\d+\s*,\s*\d+%\s*,\s*\d+%\s*(,\s*[0-9]*\.?[0-9]+\s*)?\)$/.test(color))
    return true;

  const namedColors = [
    'red',
    'green',
    'blue',
    'yellow',
    'orange',
    'purple',
    'pink',
    'brown',
    'black',
    'white',
    'gray',
    'grey',
    'cyan',
    'magenta',
    'lime',
    'maroon',
    'navy',
    'olive',
    'teal',
    'silver',
  ];
  if (namedColors.includes(color.toLowerCase())) return true;

  return false;
};

const transformReadableText = (str) => {
  let data = str.split('\n').map((i) => i.split('='));
  let output = {};
  data.forEach((d) => {
    [, output[d[0]]] = d;
  });
  return output;
};

const getBrowserName = async () => {
  const { userAgent } = navigator;
  let browserName = '';
  let nameOffset, verOffset;
  let isBrave = await navigator?.brave?.isBrave();

  if (isBrave) {
    browserName = 'Brave Browser';
  } else if ((verOffset = userAgent.indexOf('Opera')) !== -1) {
    browserName = 'Opera';
  } else if ((verOffset = userAgent.indexOf('MSIE')) !== -1) {
    browserName = 'Microsoft Internet Explorer';
  } else if ((verOffset = userAgent.indexOf('Edg')) !== -1) {
    browserName = 'Edge';
  } else if (
    (verOffset = userAgent.indexOf('Chrome')) !== -1 ||
    (verOffset = userAgent.indexOf('CriOS')) !== -1
  ) {
    browserName = 'Chrome';
  } else if ((verOffset = userAgent.indexOf('Safari')) !== -1) {
    browserName = 'Safari';
  } else if ((verOffset = userAgent.indexOf('Firefox')) !== -1) {
    browserName = 'Firefox';
  } else if (
    (nameOffset = userAgent.lastIndexOf(' ') + 1) < (verOffset = userAgent.lastIndexOf('/'))
  ) {
    browserName = userAgent.substring(nameOffset, verOffset);
    if (browserName.toLowerCase() === browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }

  return browserName;
};

const getOS = () => {
  let OSName = 'Unknown OS';
  if (navigator.userAgent.indexOf('Win') !== -1) OSName = 'Windows';
  if (navigator.userAgent.indexOf('Mac') !== -1) OSName = 'MacOS';
  if (navigator.userAgent.indexOf('X11') !== -1) OSName = 'UNIX';
  if (navigator.userAgent.indexOf('Linux') !== -1) OSName = 'Linux';

  return OSName;
};

const getDeviceName = () => {
  const navigatorBracketRegex = /\(([^)]+)\)/;
  const deviceMacRegex = /Mac/;
  const deviceAndroidRegex = /Android/;
  const deviceWindowsPhoneRegex = /Windows Phone/;
  const deviceWindowRegex = /Windows/;
  const deviceLinuxRegex = /Linux/;

  const iOSRegex = /\(([^)]+);/;
  const androidRegex = /; ([^)]+) Build/;
  const androidNameRegex = /; ([^)]+)/;

  const { userAgent } = navigator;
  const [deviceInfo] = userAgent.match(navigatorBracketRegex);

  let deviceName;

  if (deviceInfo.match(deviceMacRegex)) [, deviceName] = deviceInfo?.match(iOSRegex);
  else if (deviceInfo.match(deviceAndroidRegex))
    deviceName = deviceInfo?.match(androidRegex)?.[1]?.match(androidNameRegex)?.[1] || '';
  else if (deviceInfo.match(deviceWindowsPhoneRegex)) deviceName = 'Windows Phone';
  else if (deviceInfo.match(deviceWindowRegex)) deviceName = 'Windows';
  else if (deviceInfo.match(deviceLinuxRegex)) deviceName = 'Linux';
  else deviceName = 'Unknown';

  return deviceName;
};

const formatS3Link = (url) => {
  return url
    ? `${decodeURI(
        encodeURI(
          url
            ?.trim()
            ?.replace(process.env.REACT_APP_S3_URL, process.env.REACT_APP_CLOUD_FRONT_URL)
            ?.replace(
              'https://s3.us-west-2.amazonaws.com/prospero/',
              process.env.REACT_APP_CLOUD_FRONT_URL
            )
            ?.replace(
              'https://s3-us-west-2.amazonaws.com/prospero/',
              process.env.REACT_APP_CLOUD_FRONT_URL
            )
        )
      )}`
    : undefined;
};

// input => shorten(Bitcoin, 3, ...)
// output => Bit...
const shorten = (str, len, prefix) => {
  if (!str) return '';
  if (typeof str !== 'string' || str.length <= len) return str;
  return `${str.substring(0, len)}${prefix}`;
};

const getNumberWithOrdinal = (n) => {
  var s = ['th', 'st', 'nd', 'rd'],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const prefixCurrencySymbol = (amount, currency, locale) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  });
  const formatted = formatter.format(amount);
  return formatted;
};

export const formatDateByRegion = (locale) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const formatter = new Intl.DateTimeFormat(locale, options);
  const date = new Date();
  const dayPlaceholder = date.getDate().toString().padStart(2, '0');
  const monthPlaceholder = (date.getMonth() + 1).toString().padStart(2, '0');
  const yearPlaceholder = date.getFullYear().toString();

  const formatted = formatter.format(date);
  return formatted
    .replace(dayPlaceholder, 'DD')
    .replace(monthPlaceholder, 'MM')
    .replace(yearPlaceholder, 'YYYY');
};

const isIOS = () => {
  const iosQuirkPresent = function () {
    const audio = new Audio();

    audio.volume = 0.5;
    return audio.volume === 1; // volume cannot be changed from "1" on iOS 12 and below
  };

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAppleDevice = navigator.userAgent.includes('Macintosh');
  const isTouchScreen = navigator.maxTouchPoints >= 1; // true for iOS 13 (and hopefully beyond)

  return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
};

const isTablet = () => {
  // Check if the device supports touch
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check if the screen size is within tablet dimensions
  const isTabletSize = window.innerWidth >= 600 && window.innerWidth <= 1280;

  // Return true if all conditions are met
  return isTouchDevice && isTabletSize;
};

const rgbaToHexA = (r, g, b, a) => {
  const toHex = (n) => {
    const hex = n.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };

  const alpha = Math.round(a * 255);

  return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(alpha)}`;
};

const isWithinPastDays = (date, days) => {
  const targetDate = new Date(date);
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  targetDate.setHours(0, 0, 0, 0);

  const diffInMillis = today - targetDate;
  const diffInDays = diffInMillis / (1000 * 3600 * 24);

  return diffInDays >= 0 && diffInDays <= days;
};

/**
 * Clean amount by removing price separators and converting to standard format
 * @param {string} amount - The amount string to clean
 * @returns {string} - Cleaned amount string
 */
const cleanAmountFromPriceSeparator = (amount) => {
  if (!amount) return '0';

  // Remove all non-numeric characters except decimal point, minus sign, and spaces
  let cleaned = amount.toString().replace(/[^\d.,\-\s]/g, '');

  // Remove all spaces (thousand separators)
  cleaned = cleaned.replace(/\s/g, '');

  // Handle negative numbers
  const isNegative = cleaned.startsWith('-');
  if (isNegative) {
    cleaned = cleaned.substring(1);
  }

  // Handle different decimal separators
  // If there are multiple separators, assume the last one is the decimal separator
  const separators = cleaned.match(/[,.]/g);
  if (separators && separators.length > 1) {
    // Replace all separators except the last one with empty string
    const lastSeparatorIndex = cleaned.lastIndexOf(separators[separators.length - 1]);
    cleaned =
      cleaned.substring(0, lastSeparatorIndex).replace(/[,.]/g, '') +
      cleaned.substring(lastSeparatorIndex);
  }

  // Convert comma decimal separator to dot
  cleaned = cleaned.replace(',', '.');

  // Ensure it's a valid number
  const numValue = parseFloat(cleaned);
  if (isNaN(numValue)) return '0';

  // Apply negative sign if original was negative
  const finalValue = isNegative ? -numValue : numValue;
  return finalValue.toString();
};

/**
 * Detects if the current request is from a bot or prerender service
 * @returns {boolean} True if the request is from a bot or prerender
 */
const isBotOrPrerender = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isPrerender = document.visibilityState === 'prerender';
  const isBot =
    /bot|crawler|spider|crawling|prerender|googlebot|bingbot|yandex|baiduspider|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora|slackbot|vkshare|w3c_validator/i.test(
      userAgent
    );

  return isBot || isPrerender;
};

/**
 * Parse a single CSV line, properly handling quoted fields
 *
 * @param {string} line - CSV line to parse
 * @returns {Array} Array of field values
 */
const parseCSVLine = (line) => {
  const result = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        // Escaped quote
        current += '"';
        i++; // Skip next quote
      } else {
        // Toggle quote state
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      // End of field
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  // Add the last field
  result.push(current.trim());
  return result;
};

/**
 * Preprocess and fix common CSV formatting issues
 *
 * @param {string} csvText - Raw CSV text
 * @returns {string} - Cleaned CSV text
 */
const preprocessCSV = (csvText) => {
  let lines = csvText.split('\n');

  // Remove empty lines and lines with only commas
  lines = lines.filter((line) => {
    const trimmed = line.trim();
    return trimmed && !trimmed.match(/^,+$/);
  });

  if (lines.length === 0) {
    throw new Error('CSV file is empty or contains no valid data');
  }

  // Get expected field count from header
  const headerFields = parseCSVLine(lines[0]);
  const expectedFieldCount = headerFields.length;

  // Fix malformed records by attempting to merge broken multi-line fields
  const fixedLines = [];
  let i = 0;

  while (i < lines.length) {
    const currentLine = lines[i];
    let fields = parseCSVLine(currentLine);

    // If this is the header or has the correct field count, add it as-is
    if (i === 0 || fields.length === expectedFieldCount) {
      fixedLines.push(currentLine);
      i++;
      continue;
    }

    // If field count is less than expected, try to merge with subsequent lines
    if (fields.length < expectedFieldCount) {
      let mergedLine = currentLine;
      let mergedFields = fields;
      let j = i + 1;

      // Look ahead to find lines that might be part of this record
      while (j < lines.length && mergedFields.length < expectedFieldCount) {
        const nextLine = lines[j];
        const nextFields = parseCSVLine(nextLine);

        // If the next line has very few fields, it might be a continuation
        if (nextFields.length <= 2) {
          // Merge this line into the current record
          mergedLine += ' ' + nextLine;
          mergedFields = parseCSVLine(mergedLine);
          j++;
        } else {
          break;
        }
      }

      // If we still don't have enough fields, try a different approach
      if (mergedFields.length < expectedFieldCount) {
        // Look for a line that ends with the expected remaining fields
        while (j < lines.length) {
          const nextLine = lines[j];

          // Check if this line could complete our record
          const potentialMerged = parseCSVLine(mergedLine + ',' + nextLine);
          if (potentialMerged.length >= expectedFieldCount) {
            mergedLine += ',' + nextLine;
            mergedFields = parseCSVLine(mergedLine);
            j++;
            break;
          }
          j++;
        }
      }

      fixedLines.push(mergedLine);
      i = j;
    } else {
      // Field count is greater than expected, might be due to commas in unquoted fields
      fixedLines.push(currentLine);
      i++;
    }
  }

  return fixedLines.join('\n');
};

const helpers = {
  uuid,
  validateEmail,
  isImage,
  isValidColor,
  transformReadableText,
  getBrowserName,
  getOS,
  getDeviceName,
  formatS3Link,
  objectId,
  getNumberWithOrdinal,
  shorten,
  prefixCurrencySymbol,
  formatDateByRegion,
  isIOS,
  isTablet,
  rgbaToHexA,
  isWithinPastDays,
  cleanAmountFromPriceSeparator,
  isBotOrPrerender,
  preprocessCSV,
  parseCSVLine,
};

export default helpers;
